import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalooModule } from './baloo/baloo.module';
import { PkModule } from '@fi-app/external-platform-integration/pk/pk.module';
import { FiADIntegrationModule } from '@fi-app/external-platform-integration/ad-integration/ad-integration.module';
import { PlandayModule } from '@fi-app/external-platform-integration/planday/planday.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, FiADIntegrationModule, PkModule, BalooModule, PlandayModule],
})
export class ExternalPlatformIntegrationModule {}
